import React from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

type IconVariant = 'default' | 'action' | 'speed-to-lead';

const IconContainer = styled.div`
  width: 32px;
  height: 32px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 6px;
  border-radius: 4px;
  background-image: linear-gradient(to bottom, var(--aici-icon-gradient-start), var(--aici-icon-gradient-end));
  line-height: 0;

  &.action {
    background-image: linear-gradient(
      to right,
      var(--competitor-purple),
      var(--aici-action-icon-gradient-mid),
      var(--flamingo-pink)
    );
  }

  &.speed-to-lead {
    background-image: linear-gradient(to bottom right, var(--aici-action-icon-gradient-mid), var(--competitor-purple));
  }
`;

type Props = {
  src: string;
  variant?: IconVariant;
};

const AiCiSectionIcon = ({ src, variant = 'default' }: Props) => (
  <IconContainer className={classNames({ action: variant === 'action', 'speed-to-lead': variant === 'speed-to-lead' })}>
    <img src={src} width={20} height={20} alt="" />
  </IconContainer>
);

export default AiCiSectionIcon;
